export { default } from './AcademiesLayout';
